import { Controller } from "@hotwired/stimulus"

// Simple expand/collapse toggle for content sections.
// Targets: content (the toggleable section), trigger (the button),
//          caret (rotation indicator), label (text to swap).
export default class extends Controller {
  static targets = ["content", "trigger", "caret", "label"]

  toggle() {
    const content = this.contentTarget
    const isHidden = content.classList.contains("hidden")
    content.classList.toggle("hidden", !isHidden)

    if (this.hasCaretTarget) {
      this.caretTarget.classList.toggle("rotate-180", isHidden)
    }

    if (this.hasLabelTarget) {
      const totalText = this.labelTarget.dataset.totalText
      this.labelTarget.textContent = isHidden ? "Show less" : (totalText || this.labelTarget.textContent)
    }
  }
}
